import { render, staticRenderFns } from "./ArticleContentVideo.vue?vue&type=template&id=ee921d28"
import script from "./ArticleContentVideo.vue?vue&type=script&lang=ts"
export * from "./ArticleContentVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports